import React, { Component } from "react";
class CAPrivacyPolicyPopup extends Component{
    render(){
        return(
           <div className="privacyPopup"> 
                <p class="copy">
                </p><h2 id="CCPANoticeAtCollection" class="bold subHeader italic">California Notice At Collection</h2>
                <p></p>
                <p class="copy guidelines">
                    <span class="bold">Categories of Personal Information Collected &amp; Disclosed </span>
                </p>
                <p class="copy">
                    The following identifies the categories of Personal Information we may collect about you (and may have collected
                    in the prior 12 months). Note that our collection, use and disclosure of Personal Information about you will
                    vary depending upon the circumstances and nature of our interactions or relationship with you. Depending on how
                    you use our Services, we may collect the following categories of Personal Information:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        <span class="bold">Identifiers</span>, such as real name, alias, address, email address, date of birth,
                        policy number, salary information, social security number, driver's license number, other government
                        identifiers, and tax ID.
                    </li>
                    <li>
                        <span class="bold">Online Identifiers</span>, such as unique personal identifiers, device IDs, ad IDs, IP
                        addresses, and cookie data.
                    </li>
                    <li>
                        <span class="bold">Customer or Claimant Records</span>, such as paper or electronic customer or claimant
                        records containing Personal Information, as well as information provided by an insurance broker/agent or
                        reinsurer for underwriting purposes and information included in a list of claims, such as name, signature,
                        address, telephone number, social security number, passport number, driver's license or state identification
                        card number, insurance policy number, bank account number, payment card number, and records of personal
                        property, products or services purchased or obtained.
                    </li>
                    <li>
                        <span class="bold">Financial Information</span>, such as your bank account or credit card number and other
                        payment details.
                    </li>
                    <li>
                        <span class="bold">Usage Data</span>, such as Internet or other electronic network activity information
                        regarding a California resident's interaction with portals, Internet websites, applications, or
                        advertisements, including, but not limited to, browsing history, clickstream data, search history and
                        content of public posts.
                    </li>
                    <li>
                        <span class="bold">Geolocation Data</span>, such as physical location or movements.
                    </li>
                    <li>
                        <span class="bold">Audio, Video and Other Electronic Data</span>, such as audio information including call
                        recordings, video and photographs.
                    </li>
                    <li>
                        <span class="bold">Inferences and Preferences</span>, such as inferences drawn from any of the information
                        described in this section about a consumer including inferences reflecting the consumer's preferences,
                        characteristics, behavior and abilities.
                    </li>
                    <li>
                        <span class="bold">Sensitive Personal Information</span>, such as social security number, driver's license
                        number, racial or ethnic origin, citizenship or immigration status, religious or philosophical beliefs,
                        medical condition, and physical or mental disability.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Sources of Personal Information</span>
                </p>
                <p class="copy">
                    We generally collect Personal Information from the following categories of sources:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Directly from you and automatically;
                    </li>
                    <li>
                        Our affiliates;
                    </li>
                    <li>
                        Brokers and agents;
                    </li>
                    <li>
                        Veterinary providers; and
                    </li>
                    <li>
                        Our vendors and service providers (e.g., third party administrators).
                    </li>
                </ul>
                <p></p>


                <p class="copy guidelines">
                    <span class="bold">Purposes for Collecting and Disclosing Personal Information</span>
                </p>
                <p class="copy">
                    As described in the "<span class="bold">How We Use Personal Information</span>" section above, in general, we
                    collect and otherwise process the personal information we collect for the following business or commercial
                    purposes:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Operate our business;
                    </li>
                    <li>
                        Provide you products and services;
                    </li>
                    <li>
                        Communicate with you;
                    </li>
                    <li>
                        Evaluate and improve our products and services;
                    </li>
                    <li>
                        Analytics models to support our business;
                    </li>
                    <li>
                        Marketing and advertising;
                    </li>
                    <li>
                        Inferences;
                    </li>
                    <li>
                        Find locations on request;
                    </li>
                    <li>
                        Fraud and security purposes;
                    </li>
                    <li>
                        Legal requirements;
                    </li>
                    <li>
                        Business transfers; and
                    </li>
                    <li>
                        Other operational and business purposes.
                    </li>
                </ul>
                <p></p>

                <p class="copy guidelines">
                    <span class="bold">Sensitive Personal Information</span>
                </p>
                <p class="copy">
                    Notwithstanding the purposes described above, we do not collect, use, or disclose "sensitive personal
                    information" beyond the purposes authorized by the CCPA. Accordingly, we only use and disclose sensitive
                    personal information as reasonably necessary and proportionate: (i) to perform our services requested by you;
                    (ii) to help ensure security and integrity, including to prevent, detect, and investigate security incidents;
                    (iii) to detect, prevent and respond to malicious, fraudulent, deceptive, or illegal conduct; (iv) to verify or
                    maintain the quality and safety of our services; (v) for compliance with our legal obligations; (vi) to our
                    service providers who perform services on our behalf; and (vii) for purposes other than inferring
                    characteristics about you.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Retention of Personal Information</span>
                </p>
                <p class="copy">
                    We retain the Personal Information we collect only as reasonably necessary for the purposes described in this
                    Privacy Policy or otherwise disclosed to you at the time of collection. For example, we will retain certain
                    identifiers for as long as it is necessary to comply with our tax, accounting and recordkeeping obligations, to
                    administer certain policies and coverage, and for research, development and safety purposes, as well as an
                    additional period of time as necessary to protect, defend or establish our rights, defend against potential
                    claims, and to comply with our legal obligations. From time to time, we may also deidentify your Personal
                    Information, retain it and use it for a business purpose in compliance with CCPA.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Disclosure of Personal Information to Third Parties and Other Recipients</span>
                </p>
                <p class="copy">
                    The categories of Personal Information we may have disclosed for a business purpose in the preceding twelve (12)
                    months include: identifiers, online identifiers, customer records, financial information, usage data,
                    geolocation data, audio, video, and other electronic data, inferences, and sensitive personal information.
                </p>
                <p class="copy">
                    The categories of third parties and other recipients to whom we may disclose personal information for a business
                    purpose may include:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        Affiliates and business partners;
                    </li>
                    <li>
                        Vendors and service providers;
                    </li>
                    <li>
                        Acquirers of business assets;
                    </li>
                    <li>
                        Advisors, auditors, consultants, and representatives;
                    </li>
                    <li>
                        Agents and brokers;
                    </li>
                    <li>
                        Reinsurers;
                    </li>
                    <li>
                        Regulators, government entities, and law enforcement;
                    </li>
                    <li>
                        Operating systems and platforms; and
                    </li>
                    <li>
                        Others as required by law.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    Additionally, the CCPA defines "sale" as disclosing or making available personal information to a third-party in
                    exchange for monetary or other valuable consideration, and "sharing" includes disclosing or making available
                    personal information to a third-party for purposes of cross-contextual behavioral advertising. While we do not
                    "sell" Personal Information, we may "share" the following categories of Personal Information: online
                    identifiers, and usage data. We disclose this information to third-party advertising networks, analytics
                    providers, and social networks for purposes of marketing and advertising. We do not sell or share "sensitive
                    personal information," nor do we sell or share any Personal Information about individuals who we know are under
                    sixteen (16) years old.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Rights Regarding Your Personal Information</span>
                </p>
                <p class="copy">
                    The CCPA provides California residents with specific rights regarding Personal Information. This section
                    describes your rights under the CCPA and explains how to exercise those rights. Subject to certain exceptions,
                    California consumers have the right to make the following requests:
                </p>
                <p class="copy">
                    <span class="bold italic">Right to Know</span>. With respect to the Personal Information we have collected about
                    you in the prior (twelve) 12 months, you have the right to request from us (up to twice per year and subject to
                    certain exemptions and carveouts):
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy">
                    <li>
                        The categories of Personal Information we collected about you;
                    </li>
                    <li>
                        The sources from which we have collected that Personal Information;
                    </li>
                    <li>
                        Our business or commercial purpose for collecting, selling, or sharing that Personal Information;
                    </li>
                    <li>
                        The categories of third parties to whom we have disclosed that Personal Information; and
                    </li>
                    <li>
                        A copy of the specific pieces of your Personal Information we have collected.
                    </li>
                </ul>
                <p></p>

                <p class="copy">
                    <span class="bold italic">Right to Correct</span>. Subject to certain restrictions, you have the right to
                    request that we correct inaccuracies in your Personal Information.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Delete</span>. Subject to certain conditions and exceptions, you have the
                    right to request deletion of your Personal Information that we have collected about you.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Opt-Out</span>. You have the right to opt-out of "sales" and "sharing" of
                    your Personal Information, as those terms are defined under the CCPA. While we do not "sell" Personal
                    Information, our use of certain third-party analytics and advertising cookies may constitute "sharing" under the
                    CCPA. To exercise your right to opt-out of the "sharing" of your Personal Information, please use the <span class="italic">Do Not Sell or Share My Personal Information</span> link at the bottom of our Site.
                </p>
                <p class="copy">
                    You also have the right to opt-out of "sales" and "sharing" of your Personal Information through the use of an
                    opt-out preference signal. If our Site detects that your browser or device is transmitting an opt-out preference
                    signal, such as the "global privacy control" - or GPC - signal, we will opt that browser or device out of
                    cookies on our Site that result in a "sale" or "sharing" of your Personal Information. If you come to our Site
                    from a different device or from a different browser on the same device, you will need to opt-out, or use an
                    opt-out preference signal, for that browser and/or device as well.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Limit Use and Disclosure of Sensitive Personal Information</span>. We do not
                    engage in uses or disclosures of Personal Information that would trigger the <span class="italic">right to limit
                        use of sensitive personal information</span> under the CCPA.
                </p>

                <p class="copy">
                    <span class="bold italic">Right to Non-Discrimination</span>. We will not discriminate against you for
                    exercising any of the rights described in this section.
                </p>

                <p class="copy guidelines">
                    <span class="bold">Exercising Your Rights</span>
                </p>
                <p class="copy">
                    If you are a California resident and would like to exercise your CCPA rights, you may do so via any of the
                    methods described below:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy" style={{paddingLeft:'30px'}}>
                    <li>
                        Accessing our <a href="https://privacyportal-de.onetrust.com/webform/90614a50-71bc-4b29-ad21-25276f3948c0/23bf8860-3be8-4e0b-b97d-91885c70e8be" target="_blank">Data Subject Request</a> web page; or
                    </li>
                    <li>
                        Calling us at 1-833-324-9798
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    <span class="bold italic">Authorized Agent</span>. You may designate someone as an authorized agent to submit
                    requests and act on your behalf. Authorized agents will be required to provide proof of their authorization in
                    their first communication with us, and we may also require that you directly verify your identity and the
                    authority of your authorized agent.
                </p>
                <p class="copy">
                    Businesses operating as an authorized agent on behalf of a California resident must provide both of the
                    following:
                </p>
                <p class="copy">
                </p><ul class="blackdisc copy" style={{paddingLeft:'15px'}}>
                    <li>
                        (1) Certificate of good standing with its state of organization; and
                    </li>
                    <li>
                        (2) A written authorization document, signed by the California resident, containing the California
                        resident's name, address, telephone number, and valid email address, and expressly authorizing the business
                        to act on behalf of the California resident.
                    </li>
                </ul>
                <p></p>
                <p class="copy">
                    Individuals operating as an authorized agent on behalf of a California resident must provide a written
                    authorization document, signed by the California resident, containing the California resident's name, address,
                    telephone number, and valid email address, and expressly authorizing the individual to act on behalf of the
                    California resident.
                </p>
                <p class="copy">
                    We reserve the right to reject (1) authorized agents who have not fulfilled the above requirements, or (2)
                    automated CCPA requests where we have reason to believe the security of the requestor's personal information may
                    be at risk.
                </p>
                <p class="copy">
                    <span class="bold italic">Verification</span>. Before responding to your request, we must first verify your
                    identity using the Personal Information you recently provided to us. The information we need in order to verify
                    your identity differs depending on the request made and our relationship with you, and might include (as
                    applicable) your name, the email address you regularly use to interact with us, your phone number, your date of
                    birth, and, if available, your policy number. We will take steps to verify your request by matching the
                    information provided by you with the information we have in our records. In some cases, we may request
                    additional information to verify your identity, or where necessary to process your request. In some cases, we
                    may also carry out checks, including with third party identity verification services, to verify your identity
                    before taking any action with your Personal Information. If we are unable to verify your identity after a good
                    faith attempt, we may deny the request and, if so, will explain the basis for the denial.
                </p>
                <p class="copy guidelines">
                    <span class="bold">Artificial Intelligence</span>
                </p>
                <p class="copy">
                    We or our third party service providers may use artificial intelligence (AI) to provide products or services to
                    you,
                    <span style={{textDecoration: 'underline'}}>
                        which may involve the use of your Personal Information from the Sources described herein
                    </span>.
                    We may use AI in connection with our products or services to facilitate and service our business (e.g., assist
                    in underwriting, pricing, claims handling process or data management), as well as to enhance performance and
                    user experience on our websites and applications. The type of AI we use varies based on your relationship with
                    us and by product and service.
                </p>
                <p class="copy guidelines">
                    <span class="bold">Contact Us</span>
                </p>
                <p class="copy">
                    If you have any questions about this section of the Privacy Policy, our privacy practices, or our use of AI, or
                    if you wish to exercise your rights under California law, please contact us at:
                </p>
                <p class="copy" style={{margin: '0'}}>
                    <span class="bold">Chubb Group</span>
                </p>
                <p class="copy" style={{margin: '0'}}>Attention: NA Privacy Office</p>
                <p class="copy" style={{margin: '0'}}>202 Hall's Mill Road, P.O. Box 1600</p>
                <p class="copy" style={{margin: '0'}}>Whitehouse Station, NJ 08889-1600</p>
                <p class="copy" style={{margin: '0'}}>Telephone: 1-833-324-9798</p>
                <p class="copy" style={{margin: '0'}}>E-mail: <a href="mailTo:NAPrivacyOffice@chubb.com">NAPrivacyOffice@chubb.com</a>
                </p>
                <br />


            </div>
        )
    }
}

export default CAPrivacyPolicyPopup;